<template>
  <v-card class="candidate edit experience">
    <v-toolbar class="subheading pb-3 fr d-flex justify-center align-center" color="white" height="70" flat>
      <v-toolbar-title>
        <div class="pt-2">
          <div>No Work Experience</div>
        </div>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-slide-y-transition>
      <div v-if="!experience.id">
        <v-form v-model="valid">
          <v-card-text class="pb-0">
            <v-card-actions>
              <v-btn :color="themes.candidate.light.cancel" @click="cancel" flat>
                Cancel
              </v-btn>
              <v-btn :color="themes.candidate.light.primaryActionButton" :loading="saving" @click="submit">
                Save
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-form>
      </div>
    </v-slide-y-transition>
  </v-card>
</template>


<script>
// Vue Component
export default {
  props: {
    experience: { type: Object, required: true },
    profile: { type: Object, required: true },
  },

  data() {
    return {
      saving: false,
      show: true,
      valid: false,
    }
  },

  methods: {
    cancel() {
      this.$emit('cancelled');
    },

    submit() {
      this.saving = true
      const action = 'candidate/experiences/create'
      let experience = {
        experiences: ['None'],
        profile: this.profile,
      }

      return this.$store
        .dispatch(action, experience)
        .then(
          () => this.$store.dispatch('snackbarSuccess', 'Saved'),
          () => this.$store.dispatch('snackbarError', 'Experience not saved')
        )
        .finally(() => {
          this.$emit('cancelled')
        })
    },
  },
}
</script>
